import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import authService from '@/services/auth';

const adminRoutes = [].map((item) => {
  item.path = '/admin' + item.path;
  item.beforeEnter = (to, from, next) => {
    next();
  };
  return item;
});

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },

    {
      path: '/protocolo-mae',
      name: 'SolicitacaoMae',
      component: () => import('../views/Protocolo.vue'),
    },
    {
      path: '/protocolo',
      name: 'Protocolo',
      component: () => import('../views/Protocolo.vue'),
    },
    {
      path: '/nivel-baixo',
      name: 'nivel-baixo',
      component: () => import('../views/nivelDeGarantia/NivelBaixoView.vue'),
    },
    {
      path: '/nivel-substancial',
      name: 'nivel-substancial',
      component: () => import('../views/nivelDeGarantia/NivelSubstancialView.vue'),
    },
    {
      path: '/nivel-alto',
      name: 'nivel-alto',
      component: () => import('../views/nivelDeGarantia/NivelAltoView.vue'),
    },
    {
      path: '/protocolo-concluido/:id',
      name: 'ProtocoloConcluido',
      component: () => import('../views/ProtocoloConcluidoView.vue'),
      props: true,
    },
    {
      path: '/acompanhamento',
      name: 'PainelAcompanhamento',
      component: () => import('@/views/PainelAcompanhamento.vue')
    },
    {
      path: '/assinatura-pai/:id',
      name: 'AssinaturaPai',
      component: () => import('@/views/AssinaturaPai.vue'),
      props: true,
    },
    {
      path: '/assinar/:id',
      redirect: '/login'
    },
    {
      path: '/login-callback',
      name: 'LoginCallback',
      component: () => import('../views/LoginCallback.vue')
    },

    ...adminRoutes,
  ],
});

router.beforeEach(async (to) => {
  const publicRouteNames = [
    'home',
    'login',
    'nivel-baixo',
    'nivel-substancial',
    'nivel-alto',
    'SolicitacaoMae',
    'Protocolo',
    'AssinaturaPai',
    'assinar'
  ];

  const publicRoutePaths = [
    '/',
    '/login',
    '/nivel-baixo',
    '/nivel-substancial',
    '/nivel-alto',
    '/protocolo',
    '/protocolo-mae',
    '/assinatura-pai',
    '/assinar'
  ];

  const isPublic =
    publicRouteNames.includes(to.name) ||
    publicRoutePaths.some((p) => to.path.startsWith(p));

  const authRequired = !isPublic;

  const auth = useAuthStore();
  const { logout } = to.query;

  if (logout) {
    await auth.logoutCallback();
    return '/';
  }

  // Se precisa de autenticação
  if (auth.token || authRequired) {
    const authenticated = await auth.verifyLogin();

    if (!authenticated) {
      auth.logoutCallback();
      const loginUrl = auth.urlLogin('home');
      window.location.href = loginUrl;
      return '/';
    } else {
      if (to.name === 'login') {
        return '/';
      }
    }

    auth.user = await authService.getSelfData();
    auth.isRegistradorCivil = auth.user?.groups?.includes('/Registrador Civil');

    const possuiSolicitacoes = true; // Simulação por enquanto

    const isMae = auth.user?.groups?.includes('/Mae') || auth.user?.tipo === 'mae';
    const isPai = auth.user?.groups?.includes('/Pai') || auth.user?.tipo === 'pai';

    // Redirecionamento da HOME
    if (to.name === 'home') {
      if (auth.isRegistradorCivil) return '/protocolo';
      if ((isMae || isPai) && possuiSolicitacoes) return '/acompanhamento';
    }

    // Verificação LOA
    if (to.name === 'nivel-baixo') await auth.ensureLOA('baixo');
    if (to.name === 'nivel-substancial') await auth.ensureLOA('substancial');
    if (to.name === 'nivel-alto') await auth.ensureLOA('alto');
  }
});

export default router;
